import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import { leadFormStateOptions } from '@/features/establishmentLeadsFunnel/constants/leadFormStateOptions.constant'
import { useEstablishmentLead } from '@/features/establishmentLeadsFunnel/hooks/useEstablishmentLead'
import { useParams } from 'react-router-dom'

const Update = () => {
  const { id } = useParams()

  const {
    data: establishmentLead,
    isPending: establishmentLeadIsPending,
    error: establishmentLeadError = {} as any,
    refetch: refetchEstablishmentLead,
  } = useEstablishmentLead(id || '')

  if (establishmentLeadIsPending) return <Box>Carregando...</Box>

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={establishmentLeadError?.status}
      refetchFunction={refetchEstablishmentLead}
      notFoundButtonText='Ir para Funil de Credenciados'
    >
      {!establishmentLeadIsPending && establishmentLead && id && (
        <>
          {leadFormStateOptions.map(({ value, comp: Comp }) => {
            if (establishmentLead.state !== value) return null
            return <Comp key={establishmentLead.id} id={id} establishmentLead={establishmentLead} />
          })}
        </>
      )}
    </ErrorMessageWrapper>
  )
}

export default Update
